import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";

export type ToastState = {
  title: string;
  body: string;
  followups?: string[];
} | null;

export function Toast({
  toast,
  onClose,
  onPickFollowup,
}: {
  toast: ToastState;
  onClose: () => void;
  onPickFollowup: (text: string) => void;
}) {
  return (
    <AnimatePresence>
      {toast && (
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 16 }}
          transition={{ duration: 0.18 }}
          className="fixed bottom-6 right-6 z-50 w-[420px] rounded-2xl border border-white/15 bg-[#0a0c24]/90 p-4 shadow-[0_30px_90px_-50px_rgba(0,0,0,0.95)] backdrop-blur-xl"
        >
          <div className="flex items-start justify-between gap-3">
            <div>
              <div className="text-sm font-semibold text-white">{toast.title}</div>
              <div className="mt-2 whitespace-pre-wrap text-xs leading-relaxed text-white/70">
                {toast.body}
              </div>
            </div>
            <button
              onClick={onClose}
              className="grid h-8 w-8 place-items-center rounded-full border border-white/10 bg-white/5 hover:bg-white/10"
              aria-label="close"
            >
              <X className="h-4 w-4 text-white/70" />
            </button>
          </div>
          {toast.followups?.length ? (
            <div className="mt-3 flex flex-wrap gap-2">
              {toast.followups.map((f) => (
                <button
                  key={f}
                  onClick={() => onPickFollowup(f)}
                  className="rounded-full border border-white/10 bg-white/5 px-3 py-1 text-[11px] text-white/70 hover:bg-white/10"
                >
                  {f}
                </button>
              ))}
            </div>
          ) : null}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
